import React from 'react';
import { Controller, DeepMap, FieldError, FieldValues, FieldPath, UseControllerProps } from 'react-hook-form';
import InputText from '../../ui/InputText';
import { InputTextProps } from '../../ui/InputText/InputText';

type FormTextInputProps<T> = UseControllerProps<T & FieldValues> & {
  name: FieldPath<T & FieldValues>;
  errors?: Partial<DeepMap<T & FieldValues, FieldError>>;
} & InputTextProps;

const FormInputText = <T extends FieldValues>({ control, name, errors = {}, ...other }: FormTextInputProps<T>) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          <InputText error={errors?.[name]?.message} name={name} {...field} {...other} ref={null} />
        )}
      />
    </>
  );
};

export default FormInputText;
